// The portal groups for the app shell — portal-customers plus each desk's
// own sign-up group (GET /api/portal/groups, the guard's own portalGroups()).
// See portal-group.js.
import { useEffect, useState } from 'react';
import { client } from '@platform/http/api-client';
import { PORTAL_CUSTOMER_GROUP } from './portal-group';

// Asked once per page load: the list is the site's, not the reader's. A
// failed read falls back to portal-customers alone — the server still holds
// a desk's people to the portal; at worst they meet its refusal, not data.
let asked = null;
function fetchPortalGroups() {
  asked ||= client.get('/api/portal/groups')
    .then((r) => (Array.isArray(r.data?.groups) && r.data.groups.length ? r.data.groups : [PORTAL_CUSTOMER_GROUP]))
    .catch(() => [PORTAL_CUSTOMER_GROUP]);
  return asked;
}

/**
 * The portal groups, once the reader's own groups are known; null while
 * asking. A member of portal-customers is answered at once, without waiting.
 */
export function usePortalGroups(userGroups) {
  const known = Array.isArray(userGroups);
  const plain = known && userGroups.includes(PORTAL_CUSTOMER_GROUP);
  const [groups, setGroups] = useState(null);
  useEffect(() => {
    if (!known || plain) return undefined;
    let live = true;
    fetchPortalGroups().then((g) => { if (live) setGroups(g); });
    return () => { live = false; };
  }, [known, plain]);
  if (plain) return [PORTAL_CUSTOMER_GROUP];
  return groups;
}
